import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";

import { CoreApi } from "../helpers/Http";

/**
 *  Get DataSources
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetDataSources = (options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`/datasources`);

  return useQuery({
    queryKey: ["datasources"],
    queryFn,
    select: ({ data }) => {
        return data.map((item: any) => ({
          value: item.dataSourceId,
          label: item.dataSourceName,
        }));
      },
  });
};

/**
 *  Get Connections
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetConnectionsDataSources = (
  id: any,
  options?: UseQueryOptions
) => {
  const queryFn = async () =>
    await CoreApi.get(`datasources/${id}/connections`);

  return useQuery({
    queryKey: ["connections", id],
    queryFn,
    enabled: !!id,
    select: ({ data }) => {
      return data.map((item: any) => ({
        value: item.dataSourceConnectionId,
        label: item.connectionName,
      }));
    },
  });
};

/**
 *  Get DataSourceConnections
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetDataSourcesConnections = (
    id: any,
    options?: UseQueryOptions
  ) => {
    const queryFn = async () =>
      await CoreApi.get(`clients/${id}/platforms`);
  
    return useQuery({
      queryKey: ["platforms", id],
      queryFn,
      enabled: !!id
    });
  };


  /**
 * Update Data Sources Upload
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateDataSourcesUpload = (
	options?: UseMutationOptions
) => {
	const mutationFn = async ({ id, body }: any) =>
		await CoreApi.post(`clients/${id}/dataSources`, body);

	return useMutation({ mutationFn });
};





 /**
 * Update Data Sources Delete
 *
 * @param payload
 * @param options
 * @returns
 */

 export const useDeleteDataSources = (options?: UseMutationOptions) => {
    const mutationFn = async (id: any) =>
      await CoreApi.delete(`clients/${id}/platforms`);
    return useMutation({ mutationFn });
  };

  /**
 * Change  Data Sources Status
 *
 * @param payload
 * @param options
 * @returns
 */

export const useUpdateDataSourcesStatus = (options?: UseMutationOptions) => {
    const mutationFn = async (body: {
      id: string;
      reqBody: {
        status: boolean;
      };
    }) =>
      await CoreApi.put(`clients/${body.id}/platforms`, body.reqBody);
  
    return useMutation({ mutationFn });
};

/**
 *  Get DataSource Details
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetDataSourcesDetails = (
  id: any,
  options?: UseQueryOptions
) => {
  const queryFn = async () =>
    await CoreApi.get(`datasources/${id}/connectiondetails`);

  return useQuery({
    queryKey: [id],
    queryFn,
    enabled: !!id
  });
};